import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_DIALPLAN = "GET_LIST_DIALPLAN";
export const GET_LIST_DIALPLAN_ERROR = "GET_LIST_DIALPLAN_ERROR";
export const GET_LIST_DIALPLAN_SUCCESS = "GET_LIST_DIALPLAN_SUCCESS";

export const COUNT_LIST_DIALPLAN = "COUNT_LIST_DIALPLAN";
export const COUNT_LIST_DIALPLAN_ERROR = "COUNT_LIST_DIALPLAN_ERROR";
export const COUNT_LIST_DIALPLAN_SUCCESS = "COUNT_LIST_DIALPLAN_SUCCESS";

export const DELETE_DIALPLAN = "DELETE_DIALPLAN";
export const DELETE_DIALPLAN_ERROR = "DELETE_DIALPLAN_ERROR";
export const DELETE_DIALPLAN_SUCCESS = "DELETE_DIALPLAN_SUCCESS";

export const EDIT_DIALPLAN = "EDIT_DIALPLAN";
export const EDIT_DIALPLAN_SUCCESS = "EDIT_DIALPLAN_SUCCESS";
export const EDIT_DIALPLAN_ERROR = "EDIT_DIALPLAN_ERROR";

export const ADD_DIALPLAN = "ADD_DIALPLAN";
export const ADD_DIALPLAN_SUCCESS = "ADD_DIALPLAN_SUCCESS";
export const ADD_DIALPLAN_ERROR = "ADD_DIALPLAN_ERROR";
/**
 * Reducer
 */

const initialState = {
  dialplans: [],
  dialplan: {},
  error: false,
  count: 0,
  loading: false,
};

export const dialplanReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_DIALPLAN:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_DIALPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        dialplans: action.payload,
      };
    case GET_LIST_DIALPLAN_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_DIALPLAN:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_DIALPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload,
      };
    case COUNT_LIST_DIALPLAN_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //delete list
    case DELETE_DIALPLAN:
      return {
        ...state,
      };
    case DELETE_DIALPLAN_SUCCESS:
      return {
        ...state,
        dialplan: action.payload,
      };
    case DELETE_DIALPLAN_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //EDIT
    case EDIT_DIALPLAN:
      return {
        ...state,
      };
    case EDIT_DIALPLAN_SUCCESS:
      return {
        ...state,
        dialplan: action.payload,
      };
    case EDIT_DIALPLAN_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add
    case ADD_DIALPLAN:
      return {
        ...state,
      };
    case ADD_DIALPLAN_SUCCESS:
      return {
        ...state,
        dialplan: action.payload,
      };
    case ADD_DIALPLAN_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListDialplan = (order, limit, skip, where, query = null) => ({
  type: GET_LIST_DIALPLAN,
  data: {
    order,
    limit,
    skip,
    where,
    query,
  },
});

export const countListDialplan = (where) => ({
  type: COUNT_LIST_DIALPLAN,
  data: {
    where,
  },
});

export const deleteDialplan = (id) => ({
  type: DELETE_DIALPLAN,
  data: {
    id,
  },
});

export const editDialplan = (id, title, actions, definedName) => ({
  type: EDIT_DIALPLAN,
  data: {
    id,
    title,
    actions,
    definedName,
  },
});

export const addDialplan = (title, actions) => ({
  type: ADD_DIALPLAN,
  data: {
    title,
    actions,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListDialplan,
      deleteDialplan,
      editDialplan,
      addDialplan,
      countListDialplan,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListDialplanApi = (order, limit, skip, where, query) => {
  return apiCaller.getLogs(
    "/cloud-pbx/dial-plan",
    { order, limit, skip, ...where },
    { ...query }
  );
};

const countListDialplanApi = (where) => {
  return apiCaller.getData("/cloud-pbx/dial-plan/count", { ...where });
};

const deleteDialplanApi = (id) => {
  return apiCaller.del(`/cloud-pbx/dial-plan/${id}`);
};

const addDialplanApi = (title, actions) => {
  return apiCaller.post("/cloud-pbx/dial-plan", { title, actions });
};

const editDialplanApi = (id, title, actions, definedName) => {
  return apiCaller.put(`/cloud-pbx/dial-plan/${id}`, {
    title,
    actions,
    definedName,
  });
};

/**
 * sagas
 */

export const getListDialplanFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_DIALPLAN);
    try {
      const res = yield call(
        getListDialplanApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.query
      );
      yield put({ type: GET_LIST_DIALPLAN_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: GET_LIST_DIALPLAN_ERROR, error });
    }
  }
};

export const deleteDialplanFlow = function* () {
  while (true) {
    const action = yield take(DELETE_DIALPLAN);
    try {
      const res = yield call(deleteDialplanApi, action.data.id);
      yield put({ type: DELETE_DIALPLAN_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: DELETE_DIALPLAN_ERROR, error });
    }
  }
};
export const editDialplanFlow = function* () {
  while (true) {
    const action = yield take(EDIT_DIALPLAN);
    try {
      const res = yield call(
        editDialplanApi,
        action.data.id,
        action.data.title,
        action.data.actions,
        action.data.definedName
      );
      yield put({ type: EDIT_DIALPLAN_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: EDIT_DIALPLAN_ERROR, error });
    }
  }
};
export const addDialplanFlow = function* () {
  while (true) {
    const action = yield take(ADD_DIALPLAN);
    try {
      const res = yield call(
        addDialplanApi,
        action.data.title,
        action.data.actions
      );
      yield put({ type: ADD_DIALPLAN_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: ADD_DIALPLAN_ERROR, error });
    }
  }
};

export const countDialplanFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_DIALPLAN);
    try {
      const res = yield call(countListDialplanApi, action.data.where);
      yield put({ type: COUNT_LIST_DIALPLAN_SUCCESS, payload: res.data });
    } catch (error) {
      yield put({ type: COUNT_LIST_DIALPLAN_ERROR, error });
    }
  }
};
